import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React, { useEffect, useState } from "react"
import { FormattedMessage } from "react-intl"
import { useQuery } from "react-query"
import { useDispatch, useSelector } from "react-redux"
import { Redirect } from "react-router"
import GlobalHelper from "../../common/GlobalHelper"
import SideBar from "../../common/layout/sidebar.component"
import LoadingSpinner from "../../common/spinner/loading.component"
import PayoutService from "../../payment-account/service/payoutService"
import { INTEGRATION_KEY } from "../../state/integration/Constants"
import { setMerchantID } from "../../state/payment-processor/reducer"
import { RootState } from "../../state/store"
import { SESSION_TYPE } from "../../utils"
import PaymentProcessingTabs from "../PaymentProcessingTabs"
import PaymentAccountSelect from "../payment-listing/PaymentAccountSelect"
import {
    useGetPaymentAccounts,
    usePaymentAccountSessionByMerchantId
} from "../usePaymentAccountSession"
import NoPayoutsProcessed from "./NoPayoutsProcessed"
import PayoutStatBoxes from "./statBoxes/PayoutStatBoxes"


const PaymentProcessingPayouts = () => {
    const merchantID = useSelector((state: RootState) => state.paymentProcessing.merchantID)
    const dispatch = useDispatch()

    SideBar.activateMenu("payment-processing")

    const [dataFilters, setDataFilters] = useState<string>("")

    const {
        hasActiveAccount,
        isLoading: isLoadingPaymentAccounts,
        paymentAccounts: paymentAccounts,
        merchantID : defaultMerchantID
    } = useGetPaymentAccounts()
    const { session, isLoading: isLoadingSession } = usePaymentAccountSessionByMerchantId(SESSION_TYPE.READ_DEPOSIT, merchantID)
    const { data: payoutsCount, isLoading: isLoadingPayouts } = useQuery(["getPayoutsCount", merchantID], async () => {
        return PayoutService.getPayoutsCount(merchantID, INTEGRATION_KEY.RAINFOREST)
    }, {
        enabled: !!merchantID
    })

    useEffect(() => {
        if (!merchantID) {
            dispatch(setMerchantID(paymentAccounts?.find(pa => pa.isActive())?.getMerchantId()
            || defaultMerchantID))
        }
    }, [paymentAccounts])

    useEffect(() => {
        const filters = JSON.stringify({
            merchant_id: merchantID,
        })
        setDataFilters(filters)
    }, [merchantID])

    if(!session || isLoadingSession || isLoadingPaymentAccounts || isLoadingPayouts || !dataFilters) {
        return <LoadingSpinner />
    }

    const hasAllowedCurrency = GlobalHelper.getCountryCodeFromCurrency(AppContext.getCurrency()) === "US"
    const hasProcessedPayouts = !!payoutsCount && payoutsCount.totalPayoutsCount > 0

    return (
        <>
            {!hasAllowedCurrency && <Redirect to={"/"}/>}
            {!hasActiveAccount && <Redirect to={"/payment-processing/accounts"}/>}
            {hasAllowedCurrency && hasActiveAccount && (
                <>
                    <PaymentProcessingTabs hasActiveAccount={hasActiveAccount} />

                    <div className="d-flex flex-column gap-3">
                        {hasProcessedPayouts && <PayoutStatBoxes />}

                        <div>
                            <div className="row">
                                <div className="col-8 col-md-8 d-flex start">
                                    <h2 className="custom-lead pl-2 mb-0">
                                        <FormattedMessage
                                            id="payment_processing.payout_listing.header"
                                            defaultMessage="All Payouts"
                                        />
                                    </h2>
                                </div>
                                <div className="col-4 col-md-4 justify-content-end pr-4">
                                    <PaymentAccountSelect/>
                                </div>
                            </div>

                            {
                                !hasProcessedPayouts ?
                                    <NoPayoutsProcessed/>
                                    :
                                    <>
                                        {/* @ts-ignore */}
                                        <rainforest-deposit-report
                                            key={dataFilters}
                                            session-key={session.getSessionKey()}
                                            data-filters={dataFilters}
                                            show-export-button
                                            style-font-family={"\"Work Sans\", sans-serif"}
                                        />
                                    </>
                            }
                        </div>
                    </div>
                </>
            )}
        </>
    )

}

export default PaymentProcessingPayouts


// WEBPACK FOOTER //
// ./src/payment-processing/payout-listing/PaymentProcessingPayouts.tsx